import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);
//拦截器
Vue.http.interceptors.push((request, next) => {
    if (!request.body) {
        request.body = {};
    }
    const hostname = window.location.hostname;
    const isProd = hostname === 'jmcloud.jdx.com';

    request.url = isProd ? 'https://api.jdx.com/' + request.url : 'http://jnos-api.jdx.com/' + request.url;

    request.withCredentials = true;
    next(res => {
        if (res.body.code == 1001 &&
            (window.location.pathname == '/cloud/accountManage' || window.location.pathname == '/cloud/applyBind' || window.location.pathname == '/cloud/settle' || window.location.pathname == '/cloud/applySettle')) {
            //未登录
            window.location.href = '/cloud/login';
        } else if(res.body.code == 1002) {
            //没有组织
            window.location.href = 'https://account.jdx.com/organization.html?returnUrl=http://jmcloud.jdx.com/home';
        } else {
            return res;
        }
    });
});

export default {
    postOne(url, params, flag) {
        let options = {
            method: 'POST',
            body: params,
            url: url,
            credentials: true,
            headers: {
                'Content-Type': 'application/json',
            }
        };
        return Vue.http(options).then(res => {
            const { data, code } = res.body || {};
            if (flag || code == 1) {
                return Promise.resolve(flag ? res.body : data);
            } else {
                return Promise.reject(res);
            }
        });
    },
    get(url, params) {
        return Vue.http
            .get(url, params, {
                credentials: true
            })
            .then(res => {
                return Promise.resolve(res.body);
            });
    }
};
